<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form inline ref="form" label-width="120px" :model="autoForm">
          <el-form-item>
            <el-tag type="danger" style="font-size:14px;font-weight:bold;height:40px;line-height:40px;margin-right:10px">自动上传软件包: </el-tag>
          </el-form-item>

          <el-form-item>
            <el-button size="medium" type="primary" style="height:40px;margin-right:10px" @click="showUploadDialog">输入FTP地址生成下载链接</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <List
      url="device-rom/download/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Fresh" style="float:right;">
        <el-select multiple v-model="selectClouds" placeholder="选择存储区域(多选)" style="width:200px;margin-right:10px;" size="small">
          <el-option
            v-for="item in deviceRomStorageList"
            :label="item.name"
            :key="item.id"
            :value="item.name"
            @click.native="handleCloudSelectClick(item.name)"
            ></el-option>
        </el-select>
        <el-input
          v-model="searchData.rom_name"
          size="small"
          style="width:150px;margin-right:10px;"
          placeholder="请输入软件包名称"
          @change="search"
        ></el-input>
        <el-input
          v-model="searchData.dclient_ver"
          size="small"
          style="width:150px;margin-right:10px;"
          placeholder="请输入Dclient版本"
          @change="search"
        ></el-input>

        <label>任务状态：</label>
        <el-select v-model="selectStatus" placeholder="选择任务状态" @change="search" style="width:150px;margin-right:10px;" size="small">
          <el-option value="全部" label="全部"></el-option>
          <el-option
            v-for="status in deviceRomTaskStatus"
            :label="status"
            :key="status"
            :value="status"></el-option>
        </el-select>

        <label>固件版本类型：</label>
        <el-select v-model="selectReleaseType" placeholder="选择固件版本类型" @change="search" style="width:150px;margin-right:10px;" size="small">
          <el-option value="全部" label="全部"></el-option>
          <el-option
            v-for="release_type in deviceRomReleaseTypes"
            :label="release_type"
            :key="release_type"
            :value="release_type"></el-option>
        </el-select>

        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>
    </List>
    <DeviceRomAutoUploadAdminUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
      :clouds="deviceRomStorageList"
    ></DeviceRomAutoUploadAdminUpdateBox>

    <el-dialog title="自动上传软件包" :visible.sync="uploadDialogVisible" :close-on-click-modal="false" width="60%">
      <el-form :model="taskForm" :rules="rules" ref="form" label-width="120px">
        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="FTP地址: " prop="localUrl">
              <el-input v-model="taskForm.localUrl" placeholder="请输入FTP地址"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="软件包名称" prop="romName">
              <el-input v-model="taskForm.romName" placeholder="请输入软件包名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="软件包版本" prop="version">
              <el-input v-model="taskForm.version" placeholder="请输入软件包版本"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Dclient版本" prop="dclientVer">
              <el-input v-model="taskForm.dclientVer" placeholder="请输入Dclient版本"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
          <el-form-item label="版本类型" prop="release_type">
            <el-select v-model="taskForm.release_type" placeholder="选择版本类型">
                <el-option
                  v-for="release_type in deviceRomReleaseTypes"
                  :label="release_type"
                  :key="release_type"
                  :value="release_type"></el-option>
                </el-select>
                <el-checkbox v-model="taskForm.setAsLatest" :disabled="taskForm.release_type === '过渡版'" style="margin-left: 10px">设为最新版本（非版本发布管理人员，请不要勾选）</el-checkbox>
          </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="存储区域" prop="clouds">
              <el-select multiple v-model="taskForm.clouds" placeholder="选择存储区域(多选)">
                <el-option
                  v-for="item in deviceRomStorageList.filter(item => item.name !== '全部')"
                  :label="item.name"
                  :key="item.id"
                  :value="item.name"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="发布到对讲云" prop="cloud_api_list">
              <el-select multiple v-model="taskForm.cloud_api_list" placeholder="选择要发布的对讲云(多选)">
                <el-option
                  v-for="item in deviceRomCloudApiList"
                  :label="item.name"
                  :key="item.uuid"
                  :value="item.uuid"
                  @click.native="FormCloudApiSelectClick(item.uuid)"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="变更记录_英文" prop="changeLogEn">
              <el-input type="textarea" :rows="5" v-model="taskForm.changeLogEn" placeholder="请填写变更记录"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="变更记录_中文" prop="changeLogCn">
              <el-input type="textarea" :rows="5" v-model="taskForm.changeLogCn" placeholder="请填写变更记录"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="变更记录_日文" prop="changeLogJp">
              <el-input type="textarea" :rows="5" v-model="taskForm.changeLogJp" placeholder="请填写变更记录"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTask">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { DeviceRomTaskStatus, DeviceRomReleaseTypes } from "../components/Index/data.js";
import List from "../components/common/List.vue";
import DeviceRomAutoUploadAdminUpdateBox from "../components/DeviceRom/DeviceRomAutoUploadAdminUpdateBox.vue";

export default {
  components: {
    List,
    DeviceRomAutoUploadAdminUpdateBox
  },
  data() {
    return {
      autoForm: {},
      rules: {
        localUrl: [{ required: true, message: "请输入ftp地址", trigger: "blur" }],
        romName: [{ required: true, message: "请输入软件包名称", trigger: "blur" }],
        version: [{ required: true, message: "请输入软件包版本", trigger: "blur" }],
        dclientVer: [{required: true, message: "请输入Dclient版本", trigger: "blur"}],
        release_type: [{required: true, message: "请选择版本类型", trigger: "blur"}],
        clouds: [{required: true, message: "请选择存储区域", trigger: "blur"}],
        cloud_api_uuid_list: [{required: true, message: "请选择要发布的云平台", trigger: "blur"}]
      },
      deviceRomStorageList: {},  // 从后端获取的 cloud 列表
      selectClouds: [],
      selectStatus: "全部",
      selectReleaseType: "全部",
      deviceRomTaskStatus: DeviceRomTaskStatus,
      deviceRomReleaseTypes: DeviceRomReleaseTypes,
      deviceRomCloudApiList: {},
      title: "软件包下载链接",
      tanle: [
        { name: "rom_name", label: "软件包名称" },
        { name: "dclient_ver", label: "Dclient版本" },
        { name: "cloud", label: "存储区域" },
        { name: "url", label: "下载链接", status: "copyStatus" },
        { name: "human_readable_size", label: "文件大小" },
        { name: "cloud_api_uuid_list", label: "发布到对讲云", status: "tagStatus" },
        { name: "statusName", label: "任务状态", status: "taskStatus" },
        { name: "releaseTypeName", label: "固件版本类型" },
        { name: "rom_tag", label: "标签信息", status: "romTag" },
        { name: "update_time", label: "修改时间" },
        { name: "operator", label: "操作人" }
      ],

      searchData: {
        rom_name: "",
        dclient_ver: "",
        cloud: "",
        status: "",
        release_type: "",
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],

      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: "",
      uploadDialogVisible: false,
      isValidUrl: false,
      taskForm: {
        localUrl: "",
        romName: "",
        version: "",
        dclientVer: "6500",
        changeLogEn: "",
        changeLogCn: "",
        changeLogJp: "",
        clouds: [],
        cloud_api_uuid_list: "",
        status: "",
        release_type: "",
        setAsLatest: false,
      }
    };
  },
  watch: {
    'taskForm.release_type': function(newType) {
      // 如果选择过渡版，自动取消勾选"设为最新版本"
      if (newType === '过渡版') {
        this.taskForm.setAsLatest = false;
      }
    },
    'taskForm.clouds'(newVal) {
      if (newVal.length > 0) {
        this.fetchDeviceRomCloudApi(newVal);
      } else {
        this.deviceRomCloudApiList = {};
      }
    },
    'taskForm.localUrl': function(newUrl) {
      if (newUrl) {
        const trimmedUrl = newUrl.trim();

        this.isValidUrl = false;

        // 检查 URL 是否包含空格
        if (/\s/.test(trimmedUrl)) {
          this.$message({
            message: '下载地址不能包含空格',
            type: 'warning'
          });
          return;
        }

        // 先检查 url 是否合法
        try {
          new URL(trimmedUrl);  // 尝试创建一个 URL 对象，如果失败则说明 URL 不合法
          this.isValidUrl = true;
        } catch (e) {
          this.isValidUrl = false;
        }

        if (!this.isValidUrl) {
          this.$message({
            message: '请输入有效的下载地址',
            type: 'warning'
          });
          return;
        }

        const romName = trimmedUrl.substring(trimmedUrl.lastIndexOf('/') + 1);
        const regex = /^[a-zA-Z0-9._-]+\.[a-zA-Z0-9]+$/;

        if (regex.test(romName)) {
          this.taskForm.romName = romName;
          this.taskForm.version = romName.substring(0, romName.lastIndexOf('.'));
        } else {
          this.isValidUrl = false;
          this.$message({
            message: '升级包的文件名格式不正确，请检查下载地址是否完整',
            type: 'warning'
          });
        }
      } else {
        this.isValidUrl = false;
        this.taskForm.romName = '';
        this.taskForm.version = '';
      }
    }
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchStorageNames();
  },
  methods: {
    showUploadDialog() {
      this.uploadDialogVisible = true;
    },
    fetchStorageNames() {
      this.$http["get"](
        "device-rom/storage/", {}, (data) => {
          this.deviceRomStorageList = data.data.results.map(item => {
            return {id: item.id, name: item.cloud};
          });
          if (this.deviceRomStorageList.length > 0) {
            this.deviceRomStorageList.unshift({id: 'all', name: '全部'});
          }
        });
    },
    fetchDeviceRomCloudApi(clouds) {
      const queryParam = (clouds.length === 1 && clouds[0] === '全部') ? '' : clouds.join(',');
      this.$http["get"](
        "device-rom/cloud-api/", {cloud: queryParam}, (data) => {
          this.deviceRomCloudApiList = data.data.results.map(item => {
            return {uuid: item.uuid, name: item.name};
          });
          if (this.deviceRomCloudApiList.length > 0) {
            this.deviceRomCloudApiList.unshift({name: '全部',uuid: 'all'});
          }
          this.taskForm.cloud_api_list = [];
        });
    },
    handleCloudSelectClick(cloud){
      const isHasAllOption= this.selectClouds.some(item => item === '全部');
      const curSelectIsAllOption = cloud === '全部';
      if(isHasAllOption && curSelectIsAllOption){
        this.selectClouds = ['全部'];
      }else if(isHasAllOption && !curSelectIsAllOption){
        this.selectClouds = [cloud];
      }
      this.searchData.cloud = isHasAllOption && curSelectIsAllOption?'':this.selectClouds.join(",");
      this.search();
    },
    FormCloudApiSelectClick(cloudApi){
      const isHasAllOption= this.taskForm.cloud_api_list.some(item => item === 'all');
      const curSelectIsAllOption = cloudApi === 'all';
      if(isHasAllOption && curSelectIsAllOption){
        this.taskForm.cloud_api_list = ['all'];
      }else if(isHasAllOption && !curSelectIsAllOption){
        this.taskForm.cloud_api_list = [cloudApi];
      }
    },
    submitTask() {
      if (!this.isValidUrl) {
        this.$message({
            message: '下载地址格式不正确！',
            type: 'error'
          });
        return false;
      };

      this.$refs.form.validate(valid => {
        let formData = this.taskForm;
        if (!valid) {
          this.$message({
            message: '请检查输入是否正确！',
            type: 'error'
          });
          return false;
        };

        this.uploadDialogVisible = false;
        this.$http["post"](
          "device-rom/creater-auto-admin/",
          {
            local_url: formData.localUrl,
            rom_name: formData.romName,
            version: formData.version,
            dclient_ver: formData.dclientVer,
            release_type: DeviceRomReleaseTypes.indexOf(formData.release_type),
            set_latest: formData.setAsLatest,
            cloud: formData.clouds.join(','),
            change_log_en: formData.changeLogEn,
            change_log_cn: formData.changeLogCn,
            change_log_jp: formData.changeLogJp,
            status: DeviceRomTaskStatus.indexOf("就绪"),
            cloud_api_uuid_list: formData.cloud_api_list.join(','),
          },
          () => {
            this.$baseNotice.message("任务创建成功");
            this.updateList++;
          }
        );
      });
    },
    formatClouds(row, column, cellValue) {
      console.log('row: ', row, 'column: ', column);
      return cellValue.join(', ');
    },
    dealList(data) {
      for (let i in data) {
        data[i].update_time = this.changeDate(data[i].update_time);

        // 先根据状态索引设置 statusName
        data[i].statusName = DeviceRomTaskStatus[data[i].status];
        data[i].releaseTypeName = DeviceRomReleaseTypes[data[i].release_type];
        // 特殊状态处理（移除"就绪"和"网络超时"，让其正常显示）
        if (["定时脚本处理中", "定时脚本处理成功", "定时脚本处理失败"].includes(data[i].statusName)) {
          data[i].statusName = "进行中";
        }
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {};
      this.updateBlock = true;
    },
    edit(val) {
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
      this.updateForm.status = DeviceRomTaskStatus[val.status];
      this.updateForm.release_type = DeviceRomReleaseTypes[val.release_type];
      this.updateBlock = true;
    },
    search() {
      const clouds = this.selectClouds.join(",");
      if (clouds === '全部') {
        this.searchData.cloud = "";
      } else {
        this.searchData.cloud = clouds;
      }

      if (this.selectStatus === '全部') {
        this.searchData.status = "";
      } else {
        this.searchData.status = DeviceRomTaskStatus.indexOf(this.selectStatus);
      };

      if (this.selectReleaseType === '全部') {
        this.searchData.release_type = "";
      } else {
        this.searchData.release_type = DeviceRomReleaseTypes.indexOf(this.selectReleaseType);
      };
      this.updateList++;
    },
    deletedata(val) {
      let url = "device-rom/download/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.button-container {
  display: flex;
  justify-content: flex-end; /* 将内容右对齐 */
}

.el-loading-spinner .path {
  stroke: rgb(218, 41, 10);
}
</style>
